import React from 'react'
import HealthcareBanner from '../Healthcare/HealthcareBanner';
import HealthcareExcellence from '../Healthcare/HealthcareExcellence';
import HealthcareFacility from '../Healthcare/HealthcareFacility';
import HealthcareCounter from '../Healthcare/HealthcareCounter';
import HealthcareSmart from '../Healthcare/HealthcareSmart';
import HealthcarePremise from '../Healthcare/HealthcarePremise';
import HealthcareBrand from '../Healthcare/HealthcareBrand';
import HealthcareBusinesse from '../Healthcare/HealthcareBusinesse';
import HealthcareFaq from '../Healthcare/HealthcareFaq';
import HomeProducts from '../../home/HomeProducts';

export default function Commercial({initialData}) {

    const bannerData = {
    head: "Home",
    breadcrumb: [
      {
        slug: "/commercial-laundry-washing-machine",
        name: "Commercial"
      }
    ]

    }

    const Banner = {
        buttonText: "Global Markets",
        buttonLink: "/markets",
        title: "Built for Optimal Commercial Laundry",
        description: "Supershine offers advanced commercial laundry solutions tailored for businesses that prioritize speed, consistency, and durability, including hotels, restaurants, and laundromats. Our systems ensure efficient processing and superior fabric care while maintaining hygiene standards and managing heavy loads to minimize downtime and enhance daily performance.",
        image: "/assets/images/comercial-banner1.webp"
    };

    const excellenceData = {
        subtitle: "Advanced Commercial Technology",
        title: "Commercial Laundry Solutions Designed <br> for Productivity",
        description1: "In commercial environments, laundry operations directly impact customer satisfaction, brand image, and operational efficiency. Whether it’s hospitality linen, staff uniforms, towels, or industrial workwear, businesses need fast turnaround, consistent results, and cost control.",
        description2: "Supershine provides complete on-premise commercial laundry solutions tailored to your business needs. From system planning and equipment selection to workflow optimization and ongoing support, we help organizations improve productivity, reduce outsourcing dependency, and ensure uninterrupted operations",
        buttonText: "Talk to Our Experts",
        buttonLink: "/contact"
    };


    const facilityData = {
        title: "Why Supershine For  <br> Your Commercial Business?",
        items: [
            {
                icon: "/assets/images/commercial-icon1.webp",
                heading: " Superior Fabric Care",
                description: "Advanced drum designs and programmable cycles protect your linens, extending textile life. Keeps your favorite clothes looking fresh and new."
            },
            {
                icon: "/assets/images/commercial-icon2.webp",
                heading: "High-Speed Throughput",
                description: "Maximize your daily output with high G-force extraction that removes more water, drastically cutting down drying times and increasing turn-around."
            },
            {
                icon: "/assets/images/commercial-icon3.webp",
                heading: "Low Utility Costs",
                description: "Engineered for the bottom line, our systems use smart water-level sensing and energy-efficient motors to lower your overheads per kilogram of laundry."
            },

            {
                icon: "/assets/images/commercial-icon4.webp",
                heading: "Intuitive Controls",
                description: "Easy-to-use interfaces allow for one-touch operation, reducing staff training time and ensuring consistent wash results across every shift."
            },

            {
                icon: "/assets/images/commercial-icon5.webp",
                heading: " Maximum Durability",
                description: "Built with heavy-duty stainless steel components, Supershine machines are designed to withstand the rigors of 24/7 commercial use without failure."
            },


            {
                icon: "/assets/images/commercial-icon6.webp",
                heading: "Finishing Excellence",
                description: "Beyond washing, our integrated drying and ironing solutions ensure that every napkin and sheet is delivered with a professional, high-gloss finish."
            }
        ]
    };


    const HeathCareCounter = {
        title: "Proven Performance Across Industries",
        stats: [
            {
                end: 1200,
                suffix: "+",
                text: "Commercial & Industrial Clients <br> Served",
            },
            {
                end: 99,
                suffix: "%",
                text: "Client Satisfaction & <br> Retention Rate",
            },
            {
                end: 2000,
                suffix: "+",
                text: "Kg Capacity For High- <br> Volume Operations",
            },
            {
                prefix: "",
                end: 50,
                suffix: "%",
                text: "Faster Processing With  <br> Advanced Technology",
            },
        ],
    };

    const Fashionsmart = {
        extraClass: "",
        heading: `Eco-Smart Technology For Greener Operations`,
        description: " Modern travelers choose brands that care for the planet. Supershine helps you meet your ESG goals through resource-conscious engineering that minimizes detergent waste and maximizes water recycling, ensuring your laundry is as green as it is clean.",
        buttonText: "Learn More",
        buttonLink: "/about",
        altText: "Smart"
    };


    const PremiseData = {
        image: "/assets/images/commercial-left-image.webp",
        title: "Why Choose On-Premise Laundry with Supershine for Commercial Purposes?",
        subtitle: "The Main Reasons Are:",
        reasons: [
            "<strong>Total Quality Control: </strong>Eliminate the risk of lost or damaged items by managing your inventory in-house with Supershine equipment.",
            "<strong> Significant Cost Savings: </strong> Dras tically reduce the cost-per-room by eliminating third-party laundry service fees and transportation logistics.",
            "<strong> Immediate Turnaround:</strong>  No more waiting for delivery trucks; react instantly to high occupancy rates or special event requirements.",
            "<strong> Customized Wash Programs: </strong> Tailor your cycles for specific needs—from grease-heavy kitchen cloths to delicate silk and wool items.",
            "<strong> Proactive Maintenance: </strong> Our nationwide service network ensures your machines are always optimized, preventing costly downtime during peak seasons."
        ],
        buttonText: " Plan Your Laundry",
        buttonLink: "/contact"
    };


    const healthcareBrandData = {
        title: "",
        logos: [
            { image: "/assets/images/hospital-logos6.webp", title: "Brand 1" },
            { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
            { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
            { image: "/assets/images/hospital-new-img1.webp", title: "Brand 4" },
            { image: "/assets/images/hospital-new-img2.webp", title: "Brand 5" },
            { image: "/assets/images/hospital-new-img3.webp", title: "Brand 6" },
            { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
            { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
        ]
    };



   const businessData = {
    title: "Backed By Operators <br/> Who Scaled With Us.",
    description:
      "Built for businesses that cannot afford downtime, Supershine delivers scalable capacity and consistent performance for commercial laundry operations.",
    testimonials: [
      {
        rating: 5,
        text:
          "“As a B2B laundry service provider, our growth depends entirely on how much volume we can handle without compromising turnaround. Supershine's equipment allowed us to take on three new hotel contracts within six months of installation, without adding extra shifts. The machines have handled the increased load without a single major breakdown.”",
        client: "Manoj Tiwari, Business Owner, Commercial Laundry Service",
      },
      {
        rating: 5,
        text:
          "“Quality consistency across large daily volumes used to be our biggest challenge, especially with mixed fabric types from different clients. Supershine's systems have brought a level of standardization to our output that we simply couldn't achieve before. Client complaints about uneven quality have dropped to almost zero.”",
        client: "Farhan Sheikh, Operations Manager, Industrial Laundry Unit",
      },
      {
        rating: 5,
        text:
          "“Running a commercial laundry means every hour of downtime translates directly to lost revenue. Since switching to Supershine, our uptime has been close to constant, even during our busiest months. Their service response time whenever we've needed support has also been faster than what we got from our previous supplier.”",
        client: "Geeta Krishnan, Director, Commercial Laundry Business",
      },
    ],
  };



    const productData = {
        subtitle: "Recommended Products",
        title: "Advanced Commercial Laundry <br> Solutions for Every Industry",
    };

    const faqData = {
        title: "FAQs",
        description: "Clear answers to help you choose the right healthcare laundry solution confidently.",
        buttonText: "Talk to an expert",
        buttonLink: "/contact",
        faqs: [
            {
                question: "Which industries can benefit from Supershine commercial laundry solutions?",
                answer:
                    " Our systems are ideal for hotels, resorts, hospitals, restaurants, facilities management companies, industrial units, laundromats, and any business handling large volumes of linen or uniforms.",
            },
            {
                question: "Can Supershine systems handle heavy daily loads?",
                answer:
                    "Yes. Our machines are designed for high-capacity, continuous operations, ensuring reliable performance even under demanding workloads.",
            },
            {
                question: "How do Supershine solutions help reduce operating costs?",
                answer:
                    " Energy-efficient technology, optimized water usage, and durable equipment help lower utility bills, maintenance costs, and linen replacement expenses.",
            },

            {
                question: "Does Supershine provide installation and training?",
                answer:
                    "Yes. We offer end-to-end support, including system design, installation, staff training, and ongoing service assistance.",
            },

            {
                question: "Can the system be customized for different types of fabrics or loads?",
                answer:
                    " Yes. Programmable wash cycles allow businesses to manage different fabric types such as linen, towels, uniforms, and specialty items.",
            },

            {
                question: "How long does installation take?",
                answer:
                    "Installation timelines vary depending on project size and site readiness, but our team ensures quick and efficient deployment with minimal disruption.",
            },
        ],
    };

    return (
        <>

            <HealthcareBanner data={Banner}  breadcrumb={bannerData.breadcrumb}/>
            <HealthcareExcellence data={excellenceData} />
            <HealthcareFacility data={facilityData} />
            <HealthcareCounter data={HeathCareCounter} />
            <HealthcareSmart data={Fashionsmart} />
            <HealthcarePremise data={PremiseData} />
            <HealthcareBrand data={healthcareBrandData} />
            <HealthcareBusinesse data={businessData} />
             <HomeProducts data={productData} extraClass="healthcare-product"  initialData={initialData} />
            <HealthcareFaq data={faqData} />
        </>
    )
}







